export default {
    create : {title : "Add a Column", send : "Create"},
    update : {title : "Update Column",  send : "Update"}
}